import { render, staticRenderFns } from "./PendingDeliverOrderList.vue?vue&type=template&id=1957564c&scoped=true&"
import script from "./PendingDeliverOrderList.vue?vue&type=script&lang=js&"
export * from "./PendingDeliverOrderList.vue?vue&type=script&lang=js&"
import style0 from "./PendingDeliverOrderList.vue?vue&type=style&index=0&id=1957564c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1957564c",
  null
  
)

export default component.exports